import * as a from "react";
import T, { useContext as Y, useRef as Q } from "react";
import { _ as J, p as X, M as Z, N as ee, O as R, P as te, Q as $, q as L, a as A, n as oe, j as ne, F as re } from "./index-CjjiqU7h.mjs";
import { i as se } from "./isVisible-D3-B85BJ.mjs";
import { c as ae } from "./reactNode-CwSzDQK_.mjs";
import { _ as D, a as E } from "./asyncToGenerator-STwiOfG5.mjs";
import { R as ie } from "./index-Omb0Wmns.mjs";
var h = J({}, ie), ue = h.version, ce = h.render, le = h.unmountComponentAtNode, C;
try {
  var de = Number((ue || "").split(".")[0]);
  de >= 18 && (C = h.createRoot);
} catch {
}
function x(e) {
  var t = h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && X(t) === "object" && (t.usingClientEntryPoint = e);
}
var y = "__rc_react_root__";
function fe(e, t) {
  x(!0);
  var o = t[y] || C(t);
  x(!1), o.render(e), t[y] = o;
}
function me(e, t) {
  ce(e, t);
}
function pe(e, t) {
  if (C) {
    fe(e, t);
    return;
  }
  me(e, t);
}
function ve(e) {
  return w.apply(this, arguments);
}
function w() {
  return w = D(/* @__PURE__ */ E().mark(function e(t) {
    return E().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", Promise.resolve().then(function() {
              var r;
              (r = t[y]) === null || r === void 0 || r.unmount(), delete t[y];
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, e);
  })), w.apply(this, arguments);
}
function be(e) {
  le(e);
}
function he(e) {
  return N.apply(this, arguments);
}
function N() {
  return N = D(/* @__PURE__ */ E().mark(function e(t) {
    return E().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            if (C === void 0) {
              n.next = 2;
              break;
            }
            return n.abrupt("return", ve(t));
          case 2:
            be(t);
          case 3:
          case "end":
            return n.stop();
        }
    }, e);
  })), N.apply(this, arguments);
}
const _e = (e) => {
  const {
    componentCls: t,
    colorPrimary: o
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${o})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, Re = Z("Wave", (e) => [_e(e)]), I = `${ee}-wave-target`;
function Ee(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function S(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && Ee(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function ye(e) {
  const {
    borderTopColor: t,
    borderColor: o,
    backgroundColor: n
  } = getComputedStyle(e);
  return S(t) ? t : S(o) ? o : S(n) ? n : null;
}
function g(e) {
  return Number.isNaN(e) ? 0 : e;
}
const Ce = (e) => {
  const {
    className: t,
    target: o,
    component: n
  } = e, r = a.useRef(null), [c, f] = a.useState(null), [m, _] = a.useState([]), [l, s] = a.useState(0), [p, v] = a.useState(0), [j, P] = a.useState(0), [U, B] = a.useState(0), [F, q] = a.useState(!1), W = {
    left: l,
    top: p,
    width: j,
    height: U,
    borderRadius: m.map((u) => `${u}px`).join(" ")
  };
  c && (W["--wave-color"] = c);
  function O() {
    const u = getComputedStyle(o);
    f(ye(o));
    const i = u.position === "static", {
      borderLeftWidth: d,
      borderTopWidth: b
    } = u;
    s(i ? o.offsetLeft : g(-parseFloat(d))), v(i ? o.offsetTop : g(-parseFloat(b))), P(o.offsetWidth), B(o.offsetHeight);
    const {
      borderTopLeftRadius: z,
      borderTopRightRadius: V,
      borderBottomLeftRadius: G,
      borderBottomRightRadius: H
    } = u;
    _([z, V, H, G].map((K) => g(parseFloat(K))));
  }
  if (a.useEffect(() => {
    if (o) {
      const u = R(() => {
        O(), q(!0);
      });
      let i;
      return typeof ResizeObserver < "u" && (i = new ResizeObserver(O), i.observe(o)), () => {
        R.cancel(u), i == null || i.disconnect();
      };
    }
  }, []), !F)
    return null;
  const M = (n === "Checkbox" || n === "Radio") && (o == null ? void 0 : o.classList.contains(I));
  return /* @__PURE__ */ a.createElement(te, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (u, i) => {
      var d;
      if (i.deadline || i.propertyName === "opacity") {
        const b = (d = r.current) === null || d === void 0 ? void 0 : d.parentElement;
        he(b).then(() => {
          b == null || b.remove();
        });
      }
      return !1;
    }
  }, (u, i) => {
    let {
      className: d
    } = u;
    return /* @__PURE__ */ a.createElement("div", {
      ref: $(r, i),
      className: L(t, d, {
        "wave-quick": M
      }),
      style: W
    });
  });
}, Se = (e, t) => {
  var o;
  const {
    component: n
  } = t;
  if (n === "Checkbox" && !(!((o = e.querySelector("input")) === null || o === void 0) && o.checked))
    return;
  const r = document.createElement("div");
  r.style.position = "absolute", r.style.left = "0px", r.style.top = "0px", e == null || e.insertBefore(r, e == null ? void 0 : e.firstChild), pe(/* @__PURE__ */ a.createElement(Ce, Object.assign({}, t, {
    target: e
  })), r);
}, ge = Se, we = (e, t, o) => {
  const {
    wave: n
  } = a.useContext(A), [, r, c] = oe(), f = ne((l) => {
    const s = e.current;
    if (n != null && n.disabled || !s)
      return;
    const p = s.querySelector(`.${I}`) || s, {
      showEffect: v
    } = n || {};
    (v || ge)(p, {
      className: t,
      token: r,
      component: o,
      event: l,
      hashId: c
    });
  }), m = a.useRef();
  return (l) => {
    R.cancel(m.current), m.current = R(() => {
      f(l);
    });
  };
}, Ne = we, k = (e) => {
  const {
    children: t,
    disabled: o,
    component: n
  } = e, {
    getPrefixCls: r
  } = Y(A), c = Q(null), f = r("wave"), [, m] = Re(f), _ = Ne(c, L(f, m), n);
  if (T.useEffect(() => {
    const s = c.current;
    if (!s || s.nodeType !== 1 || o)
      return;
    const p = (v) => {
      !se(v.target) || // No need wave
      !s.getAttribute || s.getAttribute("disabled") || s.disabled || s.className.includes("disabled") || s.className.includes("-leave") || _(v);
    };
    return s.addEventListener("click", p, !0), () => {
      s.removeEventListener("click", p, !0);
    };
  }, [o]), !/* @__PURE__ */ T.isValidElement(t))
    return t ?? null;
  const l = re(t) ? $(t.ref, c) : c;
  return ae(t, {
    ref: l
  });
};
process.env.NODE_ENV !== "production" && (k.displayName = "Wave");
const Ae = k;
export {
  I as T,
  Ae as W,
  pe as r,
  he as u
};
//# sourceMappingURL=index-CmPT-VFE.mjs.map
